import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Label } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  assignEnquiry,
  enquiryChangeStatus,
  getStaff,
  showEnquiry,
} from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import Popup from "../../Common/Popup/Popup";
import AddToLead from "./AddToLead";

const EnquiryDetails = () => {
  const [loading, setLoading] = useState(false);
  const [enquiryDetails, setEnquiryDetails] = useState(null);
  const [searchParams] = useSearchParams();
  const [staffOptions, setStaffOptions] = useState([]);
  const [userOption, setuserOption] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [status, setStatus] = useState("");
  const [modal, setModal] = useState(false);

  const enquiryId = searchParams.get("id");

  const navigate = useNavigate();

  const enquiryStatusOptions = [
    { label: "New", value: "new" },
    { label: "Contacted", value: "contacted" },
    { label: "Qualified", value: "qualified" },
    { label: "Lost", value: "lost" },
  ];

  const enquiryStatusOptions2 = [
    { label: "Converted", value: "converted" },
  ];

  const handleModal = () => {
    setModal(!modal);
  };

    const getEnquiryDetails = async () => {
    setLoading(true);

    try {
      const response = await getDataWithToken(
        `${showEnquiry}?enquiry_id=${enquiryId}`,
      );

      console.log("response", response);

      if (response?.status === true) {
        const enquiryData = response?.data?.data?.[0];
        
        console.log("enquiryData", enquiryData);

        setEnquiryDetails(enquiryData);

        setStatus(enquiryData?.status || "");

        // assigned user
        if (enquiryData?.assigned_user_name) {
          setSelectedStaff({
            label: enquiryData.assigned_user_name,
            value: enquiryData.user_id,
          });
        }
      } else {
        toast.error("Failed to fetch enquiry details");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }

    setLoading(false);
  };

  // ================= GET STAFF =================

  const getStaffList = async () => {
    try {
      const response = await getDataWithToken(getStaff);

      if (response?.data?.data) {
        const options = response.data.data.map((item) => ({
          value: item.id,
          label: `${item.first_name} ${item.last_name}`,
        }));

        setStaffOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ================= ASSIGN STAFF =================

  const handleAssign = async (value) => {
    setSelectedStaff(value);

    try {
      setLoading(true);

      const postRequest = {
        enquiry_id: enquiryId,
        user_id: value?.value,
      };

      const response = await postDataWithToken(assignEnquiry, postRequest);

      if (response?.data?.status === true) {
        toast.success("Assigned successfully");

        getEnquiryDetails();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }

    setLoading(false);
  };

  // ================= CHANGE STATUS =================

  const handleChangeStatus = async (value) => {
    setStatus(value);

    try {
      setLoading(true);

      const postRequest = {
        enquiry_id: enquiryId,
        status: value,
      };

      const response = await postDataWithToken(
        enquiryChangeStatus,
        postRequest,
      );

      if (response?.data?.status === true) {
        toast.success("Status updated successfully");

        getEnquiryDetails();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }

    setLoading(false);
  };

  useEffect(() => {
    getEnquiryDetails();
    getStaffList();
  }, []);

  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Enquiry Details"
        parent="Lead Manager"
        title="Enquiry Details"
      />

      <Card>
        <CardBody>
          <Row className="mb-4">
            {/* LEFT */}
            <Col md="4">
              <h4 className="fw-bold mb-3">{enquiryDetails?.name || "N/A"}</h4>

              <p className="mb-2 fw-bold">
               {enquiryDetails?.country_code} {enquiryDetails?.phone || "N/A"}
              </p>

              <p className="fw-bold">{enquiryDetails?.email || "N/A"}</p>
            </Col>

            {/* CENTER */}
            <Col md="4">
              <div className="mb-3">
                <Label className="text-muted small">Enquiry ID</Label>

                <p className="fw-bold mb-0">
                  {enquiryDetails?.enquiry_id || "N/A"}
                </p>
              </div>

              <div>
                <Label className="text-muted small">Date</Label>

                <p className="fw-bold mb-0">
                  {enquiryDetails?.created_at || "N/A"}
                </p>
              </div>
            </Col>

            {/* RIGHT */}
            <Col md="4">
              <Label className="text-muted small">Status</Label>

              <select
                className="form-select"
                value={status}
                onChange={(e) => handleChangeStatus(e.target.value)}
                onMouseDown={(e) => {
                  if (enquiryDetails?.status === "converted") e.preventDefault();
                }}
              >
                {enquiryDetails?.status === "converted"
                  ? enquiryStatusOptions2.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))
                  : enquiryStatusOptions.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
              </select>
            </Col>
          </Row>

          {/* DETAILS */}
          <Row>
            {/* COLUMN 1 */}
            <Col md="4">
              <div className="mb-3">
                <Label className="text-muted small">Company</Label>

                <p className="fw-bold">{enquiryDetails?.company || "N/A"}</p>
              </div>

              <div className="mb-3">
                <Label className="text-muted small">City</Label>

                <p className="fw-bold">{enquiryDetails?.city || "N/A"}</p>
              </div>

              <div className="mb-3">
                <Label className="text-muted small">State</Label>

                <p className="fw-bold">{enquiryDetails?.state || "N/A"}</p>
              </div>

              <div className="mb-3">
                <Label className="text-muted small">Country</Label>

                <p className="fw-bold">{enquiryDetails?.country || "N/A"}</p>
              </div>
            </Col>

            {/* COLUMN 2 */}
            <Col md="4">
              <div className="mb-3">
                <Label className="text-muted small">Source</Label>

                <p className="fw-bold">{enquiryDetails?.source || "N/A"}</p>
              </div>

              <div className="mb-3">
                <Label className="text-muted small">Industry</Label>

                <p className="fw-bold">
                  {enquiryDetails?.industry_name || "N/A"}
                </p>
              </div>
            </Col>

            {/* COLUMN 3 */}
            <Col md="4">
              <div className="mb-3">
                <Label className="text-muted small">Assigned To</Label>

                <Typeahead
                  options={staffOptions}
                  value={selectedStaff}
                  onChange={(value) => handleAssign(value)}
                />
              </div>

              <div className="mb-3">
                <Label className="text-muted small">Address</Label>

                <p className="fw-bold">{enquiryDetails?.address || "N/A"}</p>
              </div>

              <div className="mb-3">
                <Label className="text-muted small">Notes</Label>

                <p className="fw-bold">{enquiryDetails?.notes || "N/A"}</p>
              </div>
            </Col>
          </Row>

          {/* LEAD BUTTON */}
          <div className="text-center mt-4">
            {enquiryDetails?.status === "converted" ? (
              <button
                className="btn btn-primary"
                onClick={() =>
                  navigate(
                    `${process.env.PUBLIC_URL}/lead-manage/leads-details?id=${enquiryDetails?.lead_id}`,
                  )
                }
              >
                Go To Lead
              </button>
            ) : (
              <button
              onClick={handleModal}
                className="btn btn-primary"
                disabled={enquiryDetails?.status !== "qualified"}
              >
                Convert To Lead
              </button>
            )}

            {enquiryDetails?.status !== "qualified" &&
              enquiryDetails?.status !== "converted" && (
                <p className="text-muted mt-2">
                  Please change status to <b>Qualified</b> to enable lead
                  conversion.
                </p>
              )}
          </div>
        </CardBody>
        <Popup
          title={"Add To Leads"}
          isOpen={modal}
          toggler={handleModal}
          size="md"
        >
         <AddToLead
  handleModal={handleModal}
  EnquiryDetails={enquiryDetails}
  handleAssign={handleAssign}
  selectedStaff={selectedStaff}
  staffOptions={staffOptions}
/>
        </Popup>
      </Card>
    </Fragment>
  );
};

export default EnquiryDetails;
